export const convertToUTCDateFieldString = (date) => {
    return date.replace(/ /g, 'T') + 'Z';
};

export const convertToDateTimeString = (localDateTime) => {
    if (typeof localDateTime === 'string') {
        localDateTime = localDateTime.replace(/ /g, 'T');
    }
    return convertLocalDateTimeString(localDateTime);
};

export const convertToLocalDateTimeString = (localDateTime) => {
    if (typeof localDateTime === 'string') {
        localDateTime = localDateTime.replace(/ /g, 'T');
    }
    return convertLocalDateTimeString(localDateTime);
};

export const convertToUTCDateTimeString = (localDateTime) => {
    if (typeof localDateTime === 'string') {
        localDateTime = localDateTime.replace(/ /g, 'T');
    }
    return new Date(localDateTime).toISOString().replace(/T/, ' ').replace(/\..+/, '');
};

export const isEqualDate = (date1, date2) => {
    if (typeof date1 === 'string') {
        date1 = date1.replace(/ /g, 'T');
    }
    if (typeof date2 === 'string') {
        date2 = date2.replace(/ /g, 'T');
    }
    let date1Obj = new Date(date1);
    let date2Obj = new Date(date2);
    return (
        date1Obj.getDate() === date2Obj.getDate() &&
        date1Obj.getMonth() === date2Obj.getMonth() &&
        date1Obj.getFullYear() === date2Obj.getFullYear() &&
        date1Obj.getHours() === date2Obj.getHours() &&
        date1Obj.getMinutes() === date2Obj.getMinutes()
    );
};

export const getLocalDateString = (selectedDate) => {
    var tempDateTime;
    selectedDate = new Date(selectedDate);
    tempDateTime =
        selectedDate.getFullYear() +
        '-' +
        formatDigit(selectedDate.getMonth() + 1) +
        '-' +
        formatDigit(selectedDate.getDate()) +
        'T00:00:00';
    selectedDate = new Date(tempDateTime);
    return convertToUTCDateTimeString(selectedDate);
};

export const convertLocalDateString = (utcDate) => {
    const date = new Date(convertToUTCDateFieldString(utcDate));
    return (
        formatDigit(date.getMonth() + 1) +
        '/' +
        formatDigit(date.getDate()) +
        '/' +
        date.getFullYear()
    );
};

export const convertLocalDateTimeString = (utcDate) => {
    const date = new Date(convertToUTCDateFieldString(utcDate));
    return (
        formatDigit(date.getMonth() + 1) +
        '/' +
        formatDigit(date.getDate()) +
        '/' +
        date.getFullYear() +
        ' ' +
        (date.getHours() < 10 ? '0' : '') +
        date.getHours() +
        ':' +
        (date.getMinutes() < 10 ? '0' : '') +
        date.getMinutes()
    );
};

export const convertLocalDateTimePickerFormatStringFromDateObject = (localDate) => {
    const date = new Date(localDate);
    return (
        date.getFullYear() +
        '-' +
        formatDigit(date.getMonth() + 1) +
        '-' +
        formatDigit(date.getDate()) +
        ' ' +
        (date.getHours() < 10 ? '0' : '') +
        date.getHours() +
        ':' +
        (date.getMinutes() < 10 ? '0' : '') +
        date.getMinutes() +
        ':' +
        (date.getSeconds() < 10 ? '0' : '') +
        date.getSeconds()
    );
};

export const convertLocalDateTimePickerFormatStringFromUTCDateObject = (utcDate) => {
    const date = new Date(convertToUTCDateFieldString(utcDate));
    return (
        date.getUTCFullYear() +
        '-' +
        formatDigit(date.getUTCMonth() + 1) +
        '-' +
        formatDigit(date.getUTCDate()) +
        ' ' +
        (date.getUTCHours() < 10 ? '0' : '') +
        date.getUTCHours() +
        ':' +
        (date.getUTCMinutes() < 10 ? '0' : '') +
        date.getUTCMinutes() +
        ':' +
        (date.getUTCSeconds() < 10 ? '0' : '') +
        date.getUTCSeconds()
    );
};

export const formatDigit = (number) => {
    if (parseInt(number) < 10) {
        return '0' + number;
    }
    return number.toString();
};

export const convertLocalDateTimeString1 = (utcDate) => {
    const date = new Date(utcDate);
    return (
        date.getMonth() +
        1 +
        '/' +
        date.getDate() +
        '/' +
        date.getFullYear() +
        ' ' +
        (date.getHours() < 10 ? '0' : '') +
        date.getHours() +
        ':' +
        (date.getMinutes() < 10 ? '0' : '') +
        date.getMinutes()
    );
};
